<!--
 * @Author: Gaho
 * @Date: 2024-06-20 13:40:34
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-19 18:49:20
 * @Description: 
-->
<template>
    <ModalMobile v-bind="$attrs" :model-value="modelValue" :backdrop="backdrop">
        <template #header>
            <span class="text-[24px] leading-10"> {{ t.FairnessPrinciple }} </span>
        </template>
        <div class="flex flex-col gap-6 pb-6">
            <div class="flex text-white flex-col gap-2 justify-center">
                <div>{{ t.FainessMobileContent }}</div>       
            </div>
            <div class="flex text-white flex-col gap-2 justify-center">
                <div>{{ t.PrincipleContentBefore }}</div>       
            </div>
            <div class="flex text-white flex-col gap-2 justify-center">
                <div>{{ t.PrincipleContentAfter }}</div>       
            </div>
        </div>
    </ModalMobile>
    
</template>


<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation()
const props = defineProps({
    modelValue: Boolean,
    backdrop: {
        type: Boolean,
        default: false
    },
});

watch(
    ()=>props.modelValue,
    (newVal)=>{
        // ↓ 忽略开窗事件 
        if(newVal) return;
        // ↓ 关窗时如果监测到没登录，跳到特定页面 
        jumpToNoLogPageByState();
    },
);
</script>

<style lang="scss" scoped>
.form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    >p {
        flex: 0.8;
        font-size: 12px;
    }
    > div{
        flex: 2.2;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    :deep(textarea) {
        color: white;
        padding: 6px 0;
    }
}
</style>
